module.exports = __webpack_public_path__ + "static/media/michele.a660faef.jpg";